module.exports = __webpack_public_path__ + "img/8.4-gallery.ccd26b8c.jpg";